import { noCacheDefaultSelectorFamily } from '@audacy-clients/core/atoms/helpers/noCacheDefaultSelector';
import {
  wrapBroadcastStationSongList,
  wrapStation,
} from '@audacy-clients/core/atoms/wrappers/station';
import clientServices from '@audacy-clients/core/utils/clientServices';

import { contentQuery } from './content';
import { IStation } from './wrappers/types';

export const stationsRecentlyPlayed = noCacheDefaultSelectorFamily({
  get: (id: string) => async () => {
    const list = await clientServices.getDataServices().getStationRecents(id);
    return wrapBroadcastStationSongList(list);
  },
  key: 'StationsRecent',
});

export const stationQuery = noCacheDefaultSelectorFamily({
  get:
    (stationId: string) =>
    ({ get }) => {
      const station = get(contentQuery<IStation>(stationId))?.getDataObject();
      if (!station) {
        return;
      }
      return wrapStation(station);
    },
  key: 'Station',
});
